<template>
  <Content @back="['admin'].includes(userRole) ? $router.push('/home/index?details=mans') : $router.push('/home')">
    <template v-slot:nav_left>精英集训队/训练营/参赛队</template>
    <template v-slot:nav_right>
      <div class="yioks_btn" @click="addCenterBtn = true;isEdit=false;centerUuid=''">
        添加U系列精英集训队/训练营/参赛队
      </div>
    </template>
    <template v-slot:content_right>
      <div class="select_wrap">
        <div class="select_box">
          <select v-model="selectVal.organUuid" class="yioks_select" @change="changeQuery(true)" >
            <option value='' v-if="organList.length !== 1">全部区体育行政部门</option>
            <option
              v-for="item in organList"
              :key="item.value"
              :value="item.uuid"
            >{{ item.organShortName }}</option>
          </select>
          <!-- <select v-model="selectVal.provinceCode" class="yioks_select" @change="changeProvince"  >
            <option value=''>全部省份</option>
            <option
              v-for="item in selectRegions"
              :key="item.code"
              :value="item.code"
            >{{ item.name }}</option>
          </select> -->
          <select v-model="selectVal.cityCode" class="yioks_select" @change="changeCity(true)" >
            <option value=''>全部城市</option>
            <option
              v-for="item in select_city_list"
              :key="item.code"
              :value="item.code"
            >{{ item.name }}</option>
            <!-- selectCityList -->
          </select>
          <select v-model="selectVal.countyCode" class="yioks_select" @change="changeQuery(true)" >
            <option value=''>全部区</option>
            <option
              v-for="item in select_county_list"
              :key="item.code"
              :value="item.code"
            >{{ item.name }}</option>
            <!-- selectCityList -->
          </select>
        </div>
        <div class="search_box">
          <input
            v-model.trim="selectVal.keyWord"
            type="text"
            class="yioks_input"
            placeholder="请输入关键词"
            @keyup.enter="changeQuery(true)"
          >
          <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
        </div>
      </div>
      <div class="list_wrap">
        <div v-if="showList" class="table">
          <div class="thead">
            <div class="tr">
              <div class="th seq"><strong>序号</strong></div>
              <div class="th name"><strong>精英集训队简称</strong></div>
              <div class="th org"><strong>管理单位</strong></div>
              <!--<div class="th telNumber"><strong>所属区域</strong></div>-->
              <div class="th status"><strong>类型</strong></div>
              <div class="th opt"><strong>操作</strong></div>
            </div>
          </div>
          <div class="scrollArea">
            <vue-scroll >
              <div class="tbodyWrap">
                <div class="tbody">
                  <div
                        v-for="(item, index) in centerList"
                        :key="index"
                        class="tr">
                    <div class="td seq">
                      <p>{{ index + 1 }}</p>
                    </div>
                    <div class="td name" :title="item.youthShortName">
                      <p>{{ item.youthShortName || '--' }}</p>
                    </div>
                    <div class="td org">
                      <p>{{item.organShortName}}</p>
                    </div>
                    <!--<div class="td telNumber" :title="`${item.provinceName}${item.cityName}`">-->
                      <!--<p>-->
                      <!--&lt;!&ndash; {{item.provinceName}} &ndash;&gt;-->
                      <!--{{ item.cityName}}{{item.countyName}}</p>-->
                    <!--</div>-->
                    <div class="td status">
                      <p>{{ item.trainCampType | trainCampTypeFilter }}</p>
                    </div>
                    <div class="td opt">
                      <p>
                        <span class="item" @click="goInfo(item.uuid)">查看</span>
                        <span class="split">/</span>
                        <span class="item" @click="editCenter(item.uuid)">编辑</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <yioks-loading v-if="loading" />
        <yioks-empty v-if="empty" />
      </div>
      <Pagination :total="total" :pageSize="pageSize" :page.sync="page"/>
      <template v-if="addCenterBtn">
        <AddPlayerDialog :addCenter.sync="addCenterBtn" :centerUuid="centerUuid" :organList="organList" :isEdit="isEdit" @hideDialog="hideDialog"></AddPlayerDialog>
      </template>
    </template>
  </Content>
</template>

<script>

import 'vue-awesome/icons/regular/edit'
import trainCamp from '@/api/trainCamp'
import storage from '@/utils/storage'
import person from '@/assets/images/common/person.jpg'
import regions from '@/utils/regions'
import { centerStatus } from '@/utils/yioks_filter'
import { trainCampTypeFilter } from '@/assets/js/yioksFilters'
import mixinAddressForSH from '@/mixin/mixinAddressForSH';

export default {
  mixins: [mixinAddressForSH],
  components: {
    'Content': () => import('@/components/layout/list'),
    'Pagination': () => import('@/components/Pagination'),
    'AddPlayerDialog': () => import('@/components/trainCamp'),
  },
  filters: {
    trainCampTypeFilter,
    statusFilter (val) {
      return centerStatus(val)
    }
  },
  data () {
    return {
      userRole: storage.get("userInfo").userRole,
      regions,
      centerUuid: '',
      selectRegions: regions,
      selectCityList: [],
      coach: '',
      total: 0,
      page: 0,
      pageSize: 20,
      empty: false,
      showList: false,
      person,
      addCenterBtn: false,
      loading: true,
      coachUuid: '',
      addbtnLoading: false,
      isEdit: false,
      selectVal: {
        keyWord: '',
        cityCode: '',
        provinceCode: '',
        countyCode: '',
        organUuid: ''
      },
      organList: [], // 机构列表
      centerList: [], // 青训中心列表,
      cityList: []
    }
  },
  watch: {
    page () {
      this.changeQuery()
    },
  },
  created () {
    const { page, cityCode, provinceCode,countyCode, keyWord } = this.$route.query
    page && (this.page = Number(page))
    cityCode && (this.$set(this.selectVal, 'cityCode', cityCode))
    provinceCode && (this.$set(this.selectVal, 'provinceCode', provinceCode))
    countyCode && (this.$set(this.selectVal, 'countyCode', countyCode))
    keyWord && (this.$set(this.selectVal, 'keyWord', keyWord))
    provinceCode && this.setCityList()
    // this.getCoachAccount()
    this.getOrgList(this.getCenterList)
    // this.getCenterList()
  },
  methods: {
    getCenterList () {
      this.loading = true
      this.empty = false
      this.showList = false
      let req = trainCamp.getCenterListByOrg
      const userRole = storage.get('userInfo').userRole
      if (userRole === 'system' || userRole === 'admin') { req = trainCamp.getCenterListBySystem }
      req({ page: this.page, size: this.pageSize, key: this.selectVal.keyWord, provinceCode: this.selectVal.provinceCode, cityCode: this.selectVal.cityCode, countyCode: this.selectVal.countyCode, organUuid: this.selectVal.organUuid }).then((res) => {
        this.loading = false
        let data = res.content
        this.total = res.totalElements
        if (data.length) {
          this.centerList = data
          this.showList = true
        } else {
          this.empty = true
        }
      }).catch((err) => {
        this.loading = false
        console.error(err)
      })
    },
    editCenter (uuid) {
      this.isEdit = true
      this.centerUuid = uuid
      this.addCenterBtn = true
    },
    goInfo (uuid) {
      this.$router.push({
        path: 'info',
        query: {
          uuid
        }
      })
    },
    changeProvince () {
      if (this.selectVal.provinceCode) {
        this.selectRegions.forEach(item => {
          if (item.code === this.selectVal.provinceCode) {
            this.selectCityList = item.city
            this.$set(this.selectVal, 'cityCode', '')
          }
        })
      } else {
        this.selectCityList = []
        this.$set(this.selectVal, 'cityCode', '')
      }
      this.changeQuery(true)
    },
    getOrgList (getList) {
      const userRole = storage.get('userInfo').userRole
      const uuid = storage.get('userInfo').uuid
      // eslint-disable-next-line no-unused-vars
      if (userRole === 'system' || userRole === 'admin') {
        trainCamp.getListBySystem({}).then((res) => {
          this.organList = res
          if (this.organList.length === 1) {
            this.selectVal.organUuid = this.organList[0].uuid
          }
          getList()
        }).catch((err) => {
          console.log(err)
        })
      } else {
        trainCamp.getListByOrg(uuid).then((res) => {
          this.organList = res
          if (this.organList.length === 1) {
            this.selectVal.organUuid = this.organList[0].uuid
          }
          getList()
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    changeQuery (flag) {
      if (flag) this.page = 0
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: this.page,
          cityCode: this.selectVal.cityCode,
          provinceCode: this.selectVal.provinceCode,
          countyCode: this.selectVal.countyCode,
          keyWord: this.selectVal.keyWord,
          organUuid: this.selectVal.organUuid
        }
      })
      this.getCenterList()
    },
    setCityList () {
      this.selectRegions.forEach(item => {
        if (item.code === this.selectVal.provinceCode) {
          this.selectCityList = item.city
          // this.selectVal.cityCode = this.selectCityList[0].code
        }
      })
    },
    hideDialog (val) {
      this.addCenterBtn = val
      this.getCenterList()
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .list_wrap
    flex 1
    overflow hidden
    .table {
      display flex
      flex-direction column
      flex 1
      width: 100%;
      // margin: 30px 0 0;
      .thead, .tbody {
        border: 1px solid $color_white;
      }
      .thead {
        margin: 0 40px;
        .tr {
          height: 45px;
          display: flex;
        }
      }
      .scrollArea {
        height: 425px;
        padding-bottom:15px
        /*flex 1 */
        /*overflow hidden*/
      }
      .tbodyWrap {
        display block
        // padding: 0 40px;
      }
      .tbody {
        display block
        width 810px
        margin-left auto
        margin-right auto
        max-width: 810px;
        border-top: none;
        border-bottom: none;
        .tr {
          height: 49px;
          display: flex;
          border-bottom: 1px solid $color_white;
        }
      }
      .th, .td {
        height: 100%;
        /*flex: 1 1 auto;*/
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: $font_size_medium;
        border-right: 1px solid $color_white;
      }
      .th:last-child, .td:last-child {
        border-right: none;
      }
      .td {
        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: $color_white;
        }
      }
      .seq{
        width 7%
      }
      .name{
        width 58%
        padding 0 5px
        box-sizing border-box
      }
      .org{
        width: 12%;
      }
      .status{
        width 11%
      }
      .opt{
        width: 12%;
        p{
          width 100%
          text-align center
          .item{
            cursor: pointer;
            user-select: none;
            color $green_color
          }
          .split{
            margin 0 5px
          }
        }
      }
    }
  .tip
    margin-top 10px
    color red
    width 100%
    text-align center
    word-break break-word
</style>

